import React from "react";

interface YoutubeIconSvgProps {
  smallWidth: boolean;
}

const YoutubeIconSvg: React.FC<YoutubeIconSvgProps> = ({ smallWidth }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={smallWidth ? "25" : "43"}
      height={smallWidth ? "25" : "43"}
      fill="none"
      viewBox="0 0 43 43"
    >
      <path
        fill="#16303A"
        d="M21.714 42.333c11.69 0 21.166-9.477 21.166-21.166C42.88 9.476 33.404 0 21.714 0S.547 9.477.547 21.166c0 11.69 9.477 21.167 21.167 21.167z"
      ></path>
      <path
        fill="#fff"
        d="M32.456 18.625a8.624 8.624 0 00-.91-4.162 2.913 2.913 0 00-1.718-1.016 77.646 77.646 0 00-8.363-.311 77.732 77.732 0 00-8.335.303 2.86 2.86 0 00-1.46.745 5.228 5.228 0 00-1.098 3.476 49.06 49.06 0 000 6.53c.029.68.129 1.355.3 2.015.12.508.363.978.709 1.37.406.405.924.68 1.488.785 2.154.27 4.325.384 6.496.339 3.497.05 6.565 0 10.192-.283a2.879 2.879 0 001.524-.785c.281-.286.49-.634.61-1.017.357-1.106.533-2.263.52-3.425.045-.549.045-3.956.045-4.564zm-13.25 5.184v-6.237l5.915 3.133c-1.658.928-3.846 1.974-5.915 3.104z"
      ></path>
    </svg>
  );
};

export default YoutubeIconSvg;
